import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { GamedayWrapper } from './Gameday.style';
import LiveMiniDataContainer from '@gameday/components/Live/containers/LiveMiniDataContainer';
import FinalMiniContainer from '@gameday/components/Final/containers/FinalMiniDataContainer';
import PreviewMiniDataContainer from '@gameday/components/Preview/containers/PreviewMiniDataContainer';

const PREVIEW = 'preview';
const LIVE = 'live';
const FINAL = 'final';

const gameViewMap = {
    [PREVIEW]: PreviewMiniDataContainer,
    [LIVE]: LiveMiniDataContainer,
    [FINAL]: FinalMiniContainer
};

const GamedayMini = ({
    game_view,
    componentMap = {}
}) => {
    let ComponentView = componentMap?.[game_view];
    // If mapped componentView is undefined, and not strictly null
    // use the default views for this type.
    if (ComponentView === undefined) {
        ComponentView = gameViewMap[game_view];
    }

    return (
        <GamedayWrapper>
            { ComponentView ? <ComponentView /> : null}
        </GamedayWrapper>
    );
};

GamedayMini.propTypes = {
    game_view: PropTypes.string,
    componentMap: PropTypes.object
};

export default memo(GamedayMini);
